import { useActivities } from "../lib/activities";
import { NewActivityButton } from "./NewActivity";

const F = ({ label, children }) => <label className="block"><div className="text-[10px] font-bold uppercase tracking-widest text-slate-500 mb-1">{label}</div>{children}</label>;

export const AgentPayrollFields = ({ v, setV }) => {
  const acts = useActivities();
  const t = (k, label, extra = {}) => (
    <F label={label}><input data-testid={`agent-${k.replace(/_/g, "-")}`} className="input" value={v[k] ?? ""} onChange={(e) => setV({ ...v, [k]: e.target.value })} {...extra} /></F>
  );
  return (
    <div className="grid grid-cols-3 gap-3" data-testid="agent-payroll-fields">
      {t("birth_city", "Ville de naissance")}
      {t("birth_country", "Pays de naissance")}
      {t("nationality", "Nationalité")}
      <F label="Qualification (taux de paie)">
        <select data-testid="agent-qualification" className="input" value={v.qualification || ""} onChange={(e) => setV({ ...v, qualification: e.target.value })}>
          <option value="">— Non précisée —</option>
          {acts.map((a) => <option key={a.code} value={a.code}>{a.label}</option>)}
        </select>
        <NewActivityButton testid="agent-qualification-new" className="mt-1" onCreated={(c) => setV({ ...v, qualification: c })} />
      </F>
      {t("coefficient", "Coefficient")}
      <div className="grid grid-cols-2 gap-2">{t("level", "Niveau")}{t("echelon", "Échelon")}</div>
      {t("contract_hours", "Heures du contrat / mois", { type: "number", step: "0.01", min: "0", placeholder: "151,67" })}
      <F label="Date de sortie"><div data-testid="agent-exit-date" className="text-sm py-2 text-slate-600">{v.exit_date ? v.exit_date.split("-").reverse().join("/") : "—"} <span className="text-[11px] text-slate-400">(via « Clôturer le contrat »)</span></div></F>
    </div>
  );
};

export const payrollBody = (v) => ({
  birth_city: v.birth_city || "", birth_country: v.birth_country || "", nationality: v.nationality || "",
  qualification: v.qualification || "", coefficient: v.coefficient || "", level: v.level || "", echelon: v.echelon || "",
  contract_hours: v.contract_hours === "" || v.contract_hours == null ? null : Number(v.contract_hours),
  exit_date: v.exit_date || null,
  contract_start_time: v.contract_start_time || "", dpae_ref: (v.dpae_ref || "").trim(),
});
